// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"aBh9y":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shouldKeepSpectrumClassNames", function() {
    return 0, _classNames.shouldKeepSpectrumClassNames;
});
parcelHelpers.export(exports, "keepSpectrumClassNames", function() {
    return 0, _classNames.keepSpectrumClassNames;
});
parcelHelpers.export(exports, "classNames", function() {
    return 0, _classNames.classNames;
});
parcelHelpers.export(exports, "getWrappedElement", function() {
    return 0, _getWrappedElement.getWrappedElement;
});
parcelHelpers.export(exports, "useMediaQuery", function() {
    return 0, _useMediaQuery.useMediaQuery;
});
parcelHelpers.export(exports, "createDOMRef", function() {
    return 0, _useDOMRef.createDOMRef;
});
parcelHelpers.export(exports, "createFocusableRef", function() {
    return 0, _useDOMRef.createFocusableRef;
});
parcelHelpers.export(exports, "useDOMRef", function() {
    return 0, _useDOMRef.useDOMRef;
});
parcelHelpers.export(exports, "useFocusableRef", function() {
    return 0, _useDOMRef.useFocusableRef;
});
parcelHelpers.export(exports, "unwrapDOMRef", function() {
    return 0, _useDOMRef.unwrapDOMRef;
});
parcelHelpers.export(exports, "useUnwrapDOMRef", function() {
    return 0, _useDOMRef.useUnwrapDOMRef;
});
parcelHelpers.export(exports, "baseStyleProps", function() {
    return 0, _styleProps.baseStyleProps;
});
parcelHelpers.export(exports, "viewStyleProps", function() {
    return 0, _styleProps.viewStyleProps;
});
parcelHelpers.export(exports, "dimensionValue", function() {
    return 0, _styleProps.dimensionValue;
});
parcelHelpers.export(exports, "responsiveDimensionValue", function() {
    return 0, _styleProps.responsiveDimensionValue;
});
parcelHelpers.export(exports, "convertStyleProps", function() {
    return 0, _styleProps.convertStyleProps;
});
parcelHelpers.export(exports, "useStyleProps", function() {
    return 0, _styleProps.useStyleProps;
});
parcelHelpers.export(exports, "passthroughStyle", function() {
    return 0, _styleProps.passthroughStyle;
});
parcelHelpers.export(exports, "getResponsiveProp", function() {
    return 0, _styleProps.getResponsiveProp;
});
parcelHelpers.export(exports, "useSlotProps", function() {
    return 0, _slots.useSlotProps;
});
parcelHelpers.export(exports, "cssModuleToSlots", function() {
    return 0, _slots.cssModuleToSlots;
});
parcelHelpers.export(exports, "SlotProvider", function() {
    return 0, _slots.SlotProvider;
});
parcelHelpers.export(exports, "ClearSlots", function() {
    return 0, _slots.ClearSlots;
});
parcelHelpers.export(exports, "useHasChild", function() {
    return 0, _useHasChild.useHasChild;
});
parcelHelpers.export(exports, "useIsMobileDevice", function() {
    return 0, _useIsMobileDevice.useIsMobileDevice;
});
parcelHelpers.export(exports, "useValueEffect", function() {
    return 0, _utils.useValueEffect;
});
parcelHelpers.export(exports, "BreakpointProvider", function() {
    return 0, _breakpointProvider.BreakpointProvider;
});
parcelHelpers.export(exports, "useMatchedBreakpoints", function() {
    return 0, _breakpointProvider.useMatchedBreakpoints;
});
parcelHelpers.export(exports, "useBreakpoint", function() {
    return 0, _breakpointProvider.useBreakpoint;
});
parcelHelpers.export(exports, "useResizeObserver", function() {
    return 0, _utils.useResizeObserver;
});
var _classNames = require("./classNames");
var _getWrappedElement = require("./getWrappedElement");
var _useMediaQuery = require("./useMediaQuery");
var _useDOMRef = require("./useDOMRef");
var _styleProps = require("./styleProps");
var _slots = require("./Slots");
var _useHasChild = require("./useHasChild");
var _useIsMobileDevice = require("./useIsMobileDevice");
var _utils = require("@react-aria/utils");
var _breakpointProvider = require("./BreakpointProvider");

},{"./classNames":"8umvO","./getWrappedElement":"42V6H","./useMediaQuery":"1wjrz","./useDOMRef":"goRMZ","./styleProps":"fIC5g","./Slots":"6JQjg","./useHasChild":"bfoQk","./useIsMobileDevice":"kLeWQ","@react-aria/utils":"g2eof","./BreakpointProvider":"3GPpv","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"8umvO":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shouldKeepSpectrumClassNames", function() {
    return shouldKeepSpectrumClassNames;
});
parcelHelpers.export(exports, "keepSpectrumClassNames", function() {
    return keepSpectrumClassNames;
});
parcelHelpers.export(exports, "classNames", function() {
    return classNames;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var shouldKeepSpectrumClassNames = false;
function keepSpectrumClassNames() {
    shouldKeepSpectrumClassNames = true;
    console.warn("Legacy spectrum-prefixed class names enabled for backward compatibility. We recommend replacing instances of CSS overrides targeting spectrum selectors in your app with custom class names of your own, and disabling this flag.");
}
function classNames(cssModule) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        values[_key - 1] = arguments[_key];
    }
    var classes = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            if (typeof value === 'object' && value) {
                var mapped = {};
                for(var key in value){
                    if (cssModule[key]) mapped[cssModule[key]] = value[key];
                    if (shouldKeepSpectrumClassNames || !cssModule[key]) mapped[key] = value[key];
                }
                classes.push(mapped);
            } else if (typeof value === 'string') {
                if (cssModule[value]) classes.push(cssModule[value]);
                if (shouldKeepSpectrumClassNames || !cssModule[value]) classes.push(value);
            } else classes.push(value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return (0, _clsxDefault.default).apply(void 0, (0, _toConsumableArray._)(classes));
}

},{"@swc/helpers/_/_to_consumable_array":"4Hwej","clsx":"CejKb","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"42V6H":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getWrappedElement", function() {
    return getWrappedElement;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function getWrappedElement(children) {
    var element;
    if (typeof children === 'string') element = /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, children);
    else element = (0, _reactDefault.default).Children.only(children);
    return element;
}

},{"react":"lbBKc","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"1wjrz":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMediaQuery", function() {
    return useMediaQuery;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _ssr = require("@react-aria/ssr");
function useMediaQuery(query) {
    var supportsMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia === 'function';
    var _useState = (0, _slicedToArray._)((0, _react.useState)(function() {
        return supportsMatchMedia ? window.matchMedia(query).matches : false;
    }), 2), matches = _useState[0], setMatches = _useState[1];
    (0, _react.useEffect)(function() {
        if (!supportsMatchMedia) return;
        var mq = window.matchMedia(query);
        var onChange = function(evt) {
            setMatches(evt.matches);
        };
        mq.addListener(onChange);
        return function() {
            mq.removeListener(onChange);
        };
    }, [
        supportsMatchMedia,
        query
    ]);
    // If in SSR, the media query should never match. Once the page hydrates,
    // this will update and the real value will be returned.
    var isSSR = (0, _ssr.useIsSSR)();
    return isSSR ? false : matches;
}

},{"@swc/helpers/_/_sliced_to_array":"jzEiA","react":"lbBKc","@react-aria/ssr":"jaCiN","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"goRMZ":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createDOMRef", function() {
    return createDOMRef;
});
parcelHelpers.export(exports, "createFocusableRef", function() {
    return createFocusableRef;
});
parcelHelpers.export(exports, "useDOMRef", function() {
    return useDOMRef;
});
parcelHelpers.export(exports, "useFocusableRef", function() {
    return useFocusableRef;
});
parcelHelpers.export(exports, "unwrapDOMRef", function() {
    return unwrapDOMRef;
});
parcelHelpers.export(exports, "useUnwrapDOMRef", function() {
    return useUnwrapDOMRef;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
function createDOMRef(ref) {
    return {
        UNSAFE_getDOMNode: function() {
            return ref.current;
        }
    };
}
function createFocusableRef(domRef) {
    var focusableRef = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : domRef;
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, createDOMRef(domRef)), {
        focus: function() {
            if (focusableRef.current) focusableRef.current.focus();
        }
    });
}
function useDOMRef(ref) {
    var domRef = (0, _react.useRef)(null);
    (0, _react.useImperativeHandle)(ref, function() {
        return createDOMRef(domRef);
    });
    return domRef;
}
function useFocusableRef(ref, focusableRef) {
    var domRef = (0, _react.useRef)(null);
    (0, _react.useImperativeHandle)(ref, function() {
        return createFocusableRef(domRef, focusableRef);
    });
    return domRef;
}
function unwrapDOMRef(ref) {
    return {
        get current () {
            return ref.current && ref.current.UNSAFE_getDOMNode();
        }
    };
}
function useUnwrapDOMRef(ref) {
    return (0, _react.useMemo)(function() {
        return unwrapDOMRef(ref);
    }, [
        ref
    ]);
}

},{"@swc/helpers/_/_object_spread":"96NPP","@swc/helpers/_/_object_spread_props":"1t8Sw","react":"lbBKc","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"fIC5g":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "baseStyleProps", function() {
    return baseStyleProps;
});
parcelHelpers.export(exports, "viewStyleProps", function() {
    return viewStyleProps;
});
parcelHelpers.export(exports, "dimensionValue", function() {
    return dimensionValue;
});
parcelHelpers.export(exports, "responsiveDimensionValue", function() {
    return responsiveDimensionValue;
});
parcelHelpers.export(exports, "convertStyleProps", function() {
    return convertStyleProps;
});
parcelHelpers.export(exports, "useStyleProps", function() {
    return useStyleProps;
});
parcelHelpers.export(exports, "passthroughStyle", function() {
    return passthroughStyle;
});
parcelHelpers.export(exports, "getResponsiveProp", function() {
    return getResponsiveProp;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _breakpointProvider = require("./BreakpointProvider");
var _i18N = require("@react-aria/i18n");
var baseStyleProps = {
    margin: [
        'margin',
        dimensionValue
    ],
    marginStart: [
        rtl('marginLeft', 'marginRight'),
        dimensionValue
    ],
    marginEnd: [
        rtl('marginRight', 'marginLeft'),
        dimensionValue
    ],
    // marginLeft: ['marginLeft', dimensionValue],
    // marginRight: ['marginRight', dimensionValue],
    marginTop: [
        'marginTop',
        dimensionValue
    ],
    marginBottom: [
        'marginBottom',
        dimensionValue
    ],
    marginX: [
        [
            'marginLeft',
            'marginRight'
        ],
        dimensionValue
    ],
    marginY: [
        [
            'marginTop',
            'marginBottom'
        ],
        dimensionValue
    ],
    width: [
        'width',
        dimensionValue
    ],
    height: [
        'height',
        dimensionValue
    ],
    minWidth: [
        'minWidth',
        dimensionValue
    ],
    minHeight: [
        'minHeight',
        dimensionValue
    ],
    maxWidth: [
        'maxWidth',
        dimensionValue
    ],
    maxHeight: [
        'maxHeight',
        dimensionValue
    ],
    isHidden: [
        'display',
        hiddenValue
    ],
    alignSelf: [
        'alignSelf',
        passthroughStyle
    ],
    justifySelf: [
        'justifySelf',
        passthroughStyle
    ],
    position: [
        'position',
        anyValue
    ],
    zIndex: [
        'zIndex',
        anyValue
    ],
    top: [
        'top',
        dimensionValue
    ],
    bottom: [
        'bottom',
        dimensionValue
    ],
    start: [
        rtl('left', 'right'),
        dimensionValue
    ],
    end: [
        rtl('right', 'left'),
        dimensionValue
    ],
    left: [
        'left',
        dimensionValue
    ],
    right: [
        'right',
        dimensionValue
    ],
    order: [
        'order',
        anyValue
    ],
    flex: [
        'flex',
        flexValue
    ],
    flexGrow: [
        'flexGrow',
        passthroughStyle
    ],
    flexShrink: [
        'flexShrink',
        passthroughStyle
    ],
    flexBasis: [
        'flexBasis',
        passthroughStyle
    ],
    gridArea: [
        'gridArea',
        passthroughStyle
    ],
    gridColumn: [
        'gridColumn',
        passthroughStyle
    ],
    gridColumnEnd: [
        'gridColumnEnd',
        passthroughStyle
    ],
    gridColumnStart: [
        'gridColumnStart',
        passthroughStyle
    ],
    gridRow: [
        'gridRow',
        passthroughStyle
    ],
    gridRowEnd: [
        'gridRowEnd',
        passthroughStyle
    ],
    gridRowStart: [
        'gridRowStart',
        passthroughStyle
    ]
};
var viewStyleProps = (0, _objectSpreadProps._)((0, _objectSpread._)({}, baseStyleProps), {
    backgroundColor: [
        'backgroundColor',
        backgroundColorValue
    ],
    borderWidth: [
        'borderWidth',
        borderSizeValue
    ],
    borderStartWidth: [
        rtl('borderLeftWidth', 'borderRightWidth'),
        borderSizeValue
    ],
    borderEndWidth: [
        rtl('borderRightWidth', 'borderLeftWidth'),
        borderSizeValue
    ],
    borderLeftWidth: [
        'borderLeftWidth',
        borderSizeValue
    ],
    borderRightWidth: [
        'borderRightWidth',
        borderSizeValue
    ],
    borderTopWidth: [
        'borderTopWidth',
        borderSizeValue
    ],
    borderBottomWidth: [
        'borderBottomWidth',
        borderSizeValue
    ],
    borderXWidth: [
        [
            'borderLeftWidth',
            'borderRightWidth'
        ],
        borderSizeValue
    ],
    borderYWidth: [
        [
            'borderTopWidth',
            'borderBottomWidth'
        ],
        borderSizeValue
    ],
    borderColor: [
        'borderColor',
        borderColorValue
    ],
    borderStartColor: [
        rtl('borderLeftColor', 'borderRightColor'),
        borderColorValue
    ],
    borderEndColor: [
        rtl('borderRightColor', 'borderLeftColor'),
        borderColorValue
    ],
    borderLeftColor: [
        'borderLeftColor',
        borderColorValue
    ],
    borderRightColor: [
        'borderRightColor',
        borderColorValue
    ],
    borderTopColor: [
        'borderTopColor',
        borderColorValue
    ],
    borderBottomColor: [
        'borderBottomColor',
        borderColorValue
    ],
    borderXColor: [
        [
            'borderLeftColor',
            'borderRightColor'
        ],
        borderColorValue
    ],
    borderYColor: [
        [
            'borderTopColor',
            'borderBottomColor'
        ],
        borderColorValue
    ],
    borderRadius: [
        'borderRadius',
        borderRadiusValue
    ],
    borderTopStartRadius: [
        rtl('borderTopLeftRadius', 'borderTopRightRadius'),
        borderRadiusValue
    ],
    borderTopEndRadius: [
        rtl('borderTopRightRadius', 'borderTopLeftRadius'),
        borderRadiusValue
    ],
    borderBottomStartRadius: [
        rtl('borderBottomLeftRadius', 'borderBottomRightRadius'),
        borderRadiusValue
    ],
    borderBottomEndRadius: [
        rtl('borderBottomRightRadius', 'borderBottomLeftRadius'),
        borderRadiusValue
    ],
    borderTopLeftRadius: [
        'borderTopLeftRadius',
        borderRadiusValue
    ],
    borderTopRightRadius: [
        'borderTopRightRadius',
        borderRadiusValue
    ],
    borderBottomLeftRadius: [
        'borderBottomLeftRadius',
        borderRadiusValue
    ],
    borderBottomRightRadius: [
        'borderBottomRightRadius',
        borderRadiusValue
    ],
    padding: [
        'padding',
        dimensionValue
    ],
    paddingStart: [
        rtl('paddingLeft', 'paddingRight'),
        dimensionValue
    ],
    paddingEnd: [
        rtl('paddingRight', 'paddingLeft'),
        dimensionValue
    ],
    paddingLeft: [
        'paddingLeft',
        dimensionValue
    ],
    paddingRight: [
        'paddingRight',
        dimensionValue
    ],
    paddingTop: [
        'paddingTop',
        dimensionValue
    ],
    paddingBottom: [
        'paddingBottom',
        dimensionValue
    ],
    paddingX: [
        [
            'paddingLeft',
            'paddingRight'
        ],
        dimensionValue
    ],
    paddingY: [
        [
            'paddingTop',
            'paddingBottom'
        ],
        dimensionValue
    ],
    overflow: [
        'overflow',
        passthroughStyle
    ]
});
var borderStyleProps = {
    borderWidth: 'borderStyle',
    borderLeftWidth: 'borderLeftStyle',
    borderRightWidth: 'borderRightStyle',
    borderTopWidth: 'borderTopStyle',
    borderBottomWidth: 'borderBottomStyle'
};
function rtl(ltr, rtl) {
    return function(direction) {
        return direction === 'rtl' ? rtl : ltr;
    };
}
var UNIT_RE = /(%|px|em|rem|vw|vh|auto|cm|mm|in|pt|pc|ex|ch|rem|vmin|vmax|fr)$/;
var FUNC_RE = /^\s*\w+\(/;
var SPECTRUM_VARIABLE_RE = /(static-)?size-\d+|single-line-(height|width)/g;
function dimensionValue(value) {
    if (typeof value === 'number') return value + 'px';
    if (!value) return undefined;
    if (UNIT_RE.test(value)) return value;
    if (FUNC_RE.test(value)) return value.replace(SPECTRUM_VARIABLE_RE, 'var(--spectrum-global-dimension-$&, var(--spectrum-alias-$&))');
    return "var(--spectrum-global-dimension-".concat(value, ", var(--spectrum-alias-").concat(value, "))");
}
function responsiveDimensionValue(value, matchedBreakpoints) {
    value = getResponsiveProp(value, matchedBreakpoints);
    return dimensionValue(value);
}
function colorValue(value) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'default', version = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5;
    if (version > 5) return "var(--spectrum-".concat(value, ", var(--spectrum-semantic-").concat(value, "-color-").concat(type, "))");
    return "var(--spectrum-legacy-color-".concat(value, ", var(--spectrum-global-color-").concat(value, ", var(--spectrum-semantic-").concat(value, "-color-").concat(type, ")))");
}
function backgroundColorValue(value) {
    var version = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 5;
    if (!value) return undefined;
    return "var(--spectrum-alias-background-color-".concat(value, ", ").concat(colorValue(value, 'background', version), ")");
}
function borderColorValue(value) {
    var version = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 5;
    if (!value) return undefined;
    if (value === 'default') return 'var(--spectrum-alias-border-color)';
    return "var(--spectrum-alias-border-color-".concat(value, ", ").concat(colorValue(value, 'border', version), ")");
}
function borderSizeValue(value) {
    return value && value !== 'none' ? "var(--spectrum-alias-border-size-".concat(value, ")") : '0';
}
function borderRadiusValue(value) {
    if (!value) return undefined;
    return "var(--spectrum-alias-border-radius-".concat(value, ")");
}
function hiddenValue(value) {
    return value ? 'none' : undefined;
}
function anyValue(value) {
    return value;
}
function flexValue(value) {
    if (typeof value === 'boolean') return value ? '1' : undefined;
    return '' + value;
}
function convertStyleProps(props, handlers, direction, matchedBreakpoints) {
    var style = {};
    for(var key in props){
        var styleProp = handlers[key];
        if (!styleProp || props[key] == null) continue;
        var _styleProp = (0, _slicedToArray._)(styleProp, 2), name = _styleProp[0], convert = _styleProp[1];
        if (typeof name === 'function') name = name(direction);
        var prop = getResponsiveProp(props[key], matchedBreakpoints);
        var value = convert(prop, props.colorVersion);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (Array.isArray(name)) try {
            for(var _iterator = name[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var k = _step.value;
                style[k] = value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        else style[name] = value;
    }
    for(var prop1 in borderStyleProps)if (style[prop1]) {
        style[borderStyleProps[prop1]] = 'solid';
        style.boxSizing = 'border-box';
    }
    return style;
}
function useStyleProps(props) {
    var handlers = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : baseStyleProps, options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var UNSAFE_className = props.UNSAFE_className, UNSAFE_style = props.UNSAFE_style, otherProps = (0, _objectWithoutProperties._)(props, [
        "UNSAFE_className",
        "UNSAFE_style"
    ]);
    var breakpointProvider = (0, _breakpointProvider.useBreakpoint)();
    var direction = (0, _i18N.useLocale)().direction;
    var _options_matchedBreakpoints = options.matchedBreakpoints, matchedBreakpoints = _options_matchedBreakpoints === void 0 ? (breakpointProvider === null || breakpointProvider === void 0 ? void 0 : breakpointProvider.matchedBreakpoints) || [
        'base'
    ] : _options_matchedBreakpoints;
    var styles = convertStyleProps(props, handlers, direction, matchedBreakpoints);
    var style = (0, _objectSpread._)({}, UNSAFE_style, styles);
    // @ts-ignore
    if (otherProps.className) console.warn("The className prop is unsafe and is unsupported in React Spectrum v3. Please use style props with Spectrum variables, or UNSAFE_className if you absolutely must do something custom. Note that this may break in future versions due to DOM structure changes.");
    // @ts-ignore
    if (otherProps.style) console.warn("The style prop is unsafe and is unsupported in React Spectrum v3. Please use style props with Spectrum variables, or UNSAFE_style if you absolutely must do something custom. Note that this may break in future versions due to DOM structure changes.");
    var styleProps = {
        style: style,
        className: UNSAFE_className
    };
    if (getResponsiveProp(props.isHidden, matchedBreakpoints)) styleProps.hidden = true;
    return {
        styleProps: styleProps
    };
}
function passthroughStyle(value) {
    return value;
}
function getResponsiveProp(prop, matchedBreakpoints) {
    if (prop && typeof prop === 'object' && !Array.isArray(prop)) {
        for(var i = 0; i < matchedBreakpoints.length; i++){
            var breakpoint = matchedBreakpoints[i];
            if (prop[breakpoint] != null) return prop[breakpoint];
        }
        return prop.base;
    }
    return prop;
}

},{"@swc/helpers/_/_object_spread":"96NPP","@swc/helpers/_/_object_spread_props":"1t8Sw","@swc/helpers/_/_object_without_properties":"lgaS6","@swc/helpers/_/_sliced_to_array":"jzEiA","./BreakpointProvider":"3GPpv","@react-aria/i18n":"3B1HT","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"3GPpv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BreakpointProvider", function() {
    return BreakpointProvider;
});
parcelHelpers.export(exports, "useMatchedBreakpoints", function() {
    return useMatchedBreakpoints;
});
parcelHelpers.export(exports, "useBreakpoint", function() {
    return useBreakpoint;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ssr = require("@react-aria/ssr");
var Context = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
Context.displayName = 'BreakpointContext';
function BreakpointProvider(props) {
    var children = props.children, matchedBreakpoints = props.matchedBreakpoints;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Context.Provider, {
        value: {
            matchedBreakpoints: matchedBreakpoints
        }
    }, children);
}
function useMatchedBreakpoints(breakpoints) {
    var entries = Object.entries(breakpoints).sort(function(param, param1) {
        var _param = (0, _slicedToArray._)(param, 2), valueA = _param[1], _param1 = (0, _slicedToArray._)(param1, 2), valueB = _param1[1];
        return valueB - valueA;
    });
    var breakpointQueries = entries.map(function(param) {
        var _param = (0, _slicedToArray._)(param, 2), value = _param[1];
        return "(min-width: ".concat(value, "px)");
    });
    var supportsMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia === 'function';
    var getBreakpointHandler = function() {
        var matched = [];
        for(var i in breakpointQueries){
            var query = breakpointQueries[i];
            if (window.matchMedia(query).matches) matched.push(entries[i][0]);
        }
        matched.push('base');
        return matched;
    };
    var _useState = (0, _slicedToArray._)((0, _react.useState)(function() {
        return supportsMatchMedia ? getBreakpointHandler() : [
            'base'
        ];
    }), 2), breakpoint = _useState[0], setBreakpoint = _useState[1];
    (0, _react.useEffect)(function() {
        if (!supportsMatchMedia) return;
        var onResize = function() {
            var breakpointHandler = getBreakpointHandler();
            setBreakpoint(function(previousBreakpointHandler) {
                if (previousBreakpointHandler.length !== breakpointHandler.length || previousBreakpointHandler.some(function(breakpoint, idx) {
                    return breakpoint !== breakpointHandler[idx];
                })) return (0, _toConsumableArray._)(breakpointHandler); // Return a new array to force state change
                return previousBreakpointHandler;
            });
        };
        window.addEventListener('resize', onResize);
        return function() {
            window.removeEventListener('resize', onResize);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        supportsMatchMedia
    ]);
    // If in SSR, the media query should never match. Once the page hydrates,
    // this will update and the real value will be returned.
    var isSSR = (0, _ssr.useIsSSR)();
    return isSSR ? [
        'base'
    ] : breakpoint;
}
function useBreakpoint() {
    return (0, _react.useContext)(Context);
}

},{"@swc/helpers/_/_sliced_to_array":"jzEiA","@swc/helpers/_/_to_consumable_array":"4Hwej","react":"lbBKc","@react-aria/ssr":"jaCiN","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"6JQjg":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSlotProps", function() {
    return useSlotProps;
});
parcelHelpers.export(exports, "cssModuleToSlots", function() {
    return cssModuleToSlots;
});
parcelHelpers.export(exports, "SlotProvider", function() {
    return SlotProvider;
});
parcelHelpers.export(exports, "ClearSlots", function() {
    return ClearSlots;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _utils = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SlotContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
function useSlotProps(props, defaultSlot) {
    var slot = props.slot || defaultSlot;
    var _ref = (0, _react.useContext)(SlotContext) || {}, tmp = _ref[slot], slotProps = tmp === void 0 ? {} : tmp;
    return (0, _utils.mergeProps)(props, (0, _utils.mergeProps)(slotProps, {
        id: props.id
    }));
}
function cssModuleToSlots(cssModule) {
    return Object.keys(cssModule).reduce(function(acc, slot) {
        acc[slot] = {
            UNSAFE_className: cssModule[slot]
        };
        return acc;
    }, {});
}
function SlotProvider(props) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var parentSlots = (0, _react.useContext)(SlotContext) || {};
    var _props_slots = props.slots, slots = _props_slots === void 0 ? {} : _props_slots, children = props.children;
    // Merge props for each slot from parent context and props
    var value = (0, _react.useMemo)(function() {
        return Object.keys(parentSlots).concat(Object.keys(slots)).reduce(function(o, p) {
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, o), (0, _defineProperty._)({}, p, (0, _utils.mergeProps)(parentSlots[p] || {}, slots[p] || {})));
        }, {});
    }, [
        parentSlots,
        slots
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(SlotContext.Provider, {
        value: value
    }, children);
}
function ClearSlots(props) {
    var children = props.children, otherProps = (0, _objectWithoutProperties._)(props, [
        "children"
    ]);
    var content = children;
    if ((0, _reactDefault.default).Children.toArray(children).length <= 1) {
        if (typeof children === 'function') content = /*#__PURE__*/ (0, _reactDefault.default).cloneElement((0, _reactDefault.default).Children.only(children), otherProps);
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(SlotContext.Provider, {
        value: {}
    }, content);
}

},{"@swc/helpers/_/_define_property":"5nkYf","@swc/helpers/_/_object_spread":"96NPP","@swc/helpers/_/_object_spread_props":"1t8Sw","@swc/helpers/_/_object_without_properties":"lgaS6","@react-aria/utils":"g2eof","react":"lbBKc","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"bfoQk":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useHasChild", function() {
    return useHasChild;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _utils = require("@react-aria/utils");
function useHasChild(query, ref) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(true), 2), hasChild = _useState[0], setHasChild = _useState[1];
    (0, _utils.useLayoutEffect)(function() {
        setHasChild(!!(ref.current && ref.current.querySelector(query)));
    }, [
        setHasChild,
        query,
        ref
    ]);
    return hasChild;
}

},{"@swc/helpers/_/_sliced_to_array":"jzEiA","react":"lbBKc","@react-aria/utils":"g2eof","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"kLeWQ":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsMobileDevice", function() {
    return useIsMobileDevice;
});
var _ssr = require("@react-aria/ssr");
var MOBILE_SCREEN_WIDTH = 700;
function useIsMobileDevice() {
    var isSSR = (0, _ssr.useIsSSR)();
    if (isSSR || typeof window === 'undefined') return false;
    return window.screen.width <= MOBILE_SCREEN_WIDTH;
}

},{"@react-aria/ssr":"jaCiN","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}]},[], null, "parcelRequire94c2")

//# sourceMappingURL=useCalendar.stories.0bf226b1.js.map
